import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';

const UnpublishedChangesContext = createContext(null);

export const UnpublishedChangesProvider = ({ children }) => {
  const [unpublishedChanges, setUnpublishedChanges] = useState({});
  const [unpublishedTaskIds, setUnpublishedTaskIds] = useState({});

  const { user, isImpersonating, impersonatedUser } = useAuth();
  const effectiveEmail = isImpersonating ? impersonatedUser?.email : user?.email;

  // Clear all unpublished state whenever the active identity changes (impersonation start/end, login/logout).
  // The per-page init effects will re-seed from fresh task data for the new user.
  useEffect(() => {
    setUnpublishedChanges({});
    setUnpublishedTaskIds({});
  }, [effectiveEmail]);

  // Self-heal: remove any task ID sets whose badge entry is missing (orange cards without badge)
  useEffect(() => {
    const changesKeys = new Set(Object.keys(unpublishedChanges));
    const orphaned = Object.keys(unpublishedTaskIds).filter(k => !changesKeys.has(k));
    if (orphaned.length > 0) {
      console.warn('[UnpublishedChanges] repairing orphaned task IDs for:', orphaned);
      setUnpublishedTaskIds(prev => {
        const next = { ...prev };
        orphaned.forEach(k => delete next[k]);
        return next;
      });
    }
  }, [unpublishedChanges, unpublishedTaskIds]);

  return (
    <UnpublishedChangesContext.Provider value={{ unpublishedChanges, setUnpublishedChanges, unpublishedTaskIds, setUnpublishedTaskIds }}>
      {children}
    </UnpublishedChangesContext.Provider>
  );
};

export const useUnpublishedChanges = () => useContext(UnpublishedChangesContext);
